import { designExtractApi, designValidationApi, extractWeightApi } from "api";
import { fileToBase64 } from "utils/jewelleryHelpers";

class jewelleryClient {
    async designExtract({ image, prompt, type }) {
        try {
            const response = await designExtractApi({
                image,
                prompt: prompt.trim(),
                type
            });
            return { data: response.data };
        } catch (error) {
            console.error("Error in designExtractApi:", error);
            return { error: error.response?.data?.error || error.message || "An error occurred while processing the image" };
        }
    }

    async designExtractValidate({ rows, type }) {
        try {
            const response = await designValidationApi({ rows: rows, type });
            return { data: response.data.aggregated };
        } catch (error) {
            return { error: error.response?.data?.error || error.message || "An error occurred while validation" };
        }
    }

    async base64Image({ file }) {
        try {
            const response = await fileToBase64(file);
            return { base64Url: response };
        } catch (error) {
            return { error: error.message || "An error occurred while converting the file to base64" };
        }
    }

    async fetchWeights({ tableData, tableKey }) {
        try {
            const stoneDetails = tableData[tableKey] || [];
            const payload = {
                stone_details: stoneDetails.map(item => ({
                    sieve_size: item.sieve_size || "NA"
                }))
            };

            const response = await extractWeightApi(payload);

           if (!response || !response.data) {
                throw new Error("Failed to fetch weights");
            }

            const weightData = response.data;
            
             console.log('weightData',weightData)
             console.log('tableKey',tableKey)
            // Return the updated data structure
            return {
                data: tableData[tableKey].map((item, index) => {
                    const weightInfo = weightData.data[index]?.matchedData
;                   console.log('weightInfo',weightInfo)
                    return {
                        ...item,
                        pp_wt: weightInfo?.PPWeight || null
                    };
                })
            };
        } catch (error) {
            console.error("Error fetching weights:", error);
            return { error: error.response?.data?.error || error.message || "An error occurred while fetching weights" };
        }
    }
}

const jewelleryClientInstance = new jewelleryClient();

export default jewelleryClientInstance;